import type {Ref} from 'vue'
import {appInstance} from '~/utils/app-accessor'

export function useProductRuntimeStore() {
    const country: Ref = ref({})
    const offers: Ref<any[]> = ref([])
    const filterActiveCount = ref(0)
    const searchActiveCount = ref(0)
    const partialSearchResultsCTS: Ref = ref(null)
    const partialSearchTimeoutInstance: Ref = ref(null)

    function SET_OFFERS(val: any) {
        offers.value = val
    }

    function START_SEARCH() {
        searchActiveCount.value++
    }

    function STOP_SEARCH() {
        searchActiveCount.value--
    }

    function SET_PARTIAL_SEARCH_RESULTS_CTS(cancelTokenSource: any) {
        partialSearchResultsCTS.value = cancelTokenSource
    }

    function SET_PARTIAL_SEARCH_TIMEOUT_INSTANCE(timeoutInstance: any) {
        partialSearchTimeoutInstance.value = timeoutInstance
    }

    function START_FILTER() {
        filterActiveCount.value++
    }

    function STOP_FILTER() {
        filterActiveCount.value--
    }

    function stopSearch() {
        if (partialSearchResultsCTS.value) partialSearchResultsCTS.value.cancel()
        if (partialSearchTimeoutInstance.value) partialSearchTimeoutInstance.value.cancel()
    }

    async function loadCountry(id: any) {
        try {
            const {
                countries: [_country],
            } = await appInstance.$api.locations.get({id, limitCountries: 1})
            country.value = _country
        } catch (e) {
            country.value = {}
        }
    }

    const filterActive = computed(() => filterActiveCount.value > 0)
    const searchActive = computed(() => searchActiveCount.value > 0)

    return {
        country,
        offers,
        filterActiveCount,
        searchActiveCount,
        partialSearchResultsCTS,
        partialSearchTimeoutInstance,
        SET_OFFERS,
        START_SEARCH,
        STOP_SEARCH,
        SET_PARTIAL_SEARCH_RESULTS_CTS,
        SET_PARTIAL_SEARCH_TIMEOUT_INSTANCE,
        START_FILTER,
        STOP_FILTER,
        stopSearch,
        loadCountry,
        filterActive,
        searchActive,
    }
}
